import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { ToastrService } from 'ngx-toastr';
import { log } from 'src/app/utils/logging';
import { Agent, ITeamCheckIn } from 'src/app/interfaces/agent.interface';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { TranslocoService } from '@ngneat/transloco';
import { WebRTCService } from 'src/app/services/webrtc.service';
import { TeamCheckInService } from 'src/app/services/team.checkin.service';

@Component({
  selector: 'app-single-agent',
  templateUrl: './single-agent.component.html',
  styleUrls: ['./single-agent.component.sass'],
  host: {
    '(document:click)': 'onClick($event)',
  },
})

export class SingleAgentComponent implements OnInit {
  @Input() agent: Agent;
  @Input() archivedView = false;
  @Input() isSidebar = false;
  appConfig = AppConfig;
  menuAgentLanId = '';
  setLogUpload = false;
  agentConnectivityStatus = {
    class: "",
    status: "",
    tooltip: "",
  };

  @ViewChild('agentView', { read: ElementRef }) public agentView: ElementRef<any>;

  isProfilePictureLoaded: boolean = false;
  loadedProfilePictureSource: string = "";

  checkInInfo: ITeamCheckIn = {
    LanId: "",
    ImageUrl: "",
    ImageCaptureDateTime: new Date()
  }

  pinLabel: string = "";
  pinnedLabel: string = "";
  optionsLabel: string = "";
  archiveLabel: string = "";
  unarchiveLabel: string = "";
  uploadLogsLabel: string = "";
  chatReceivedLabel: string = "";
  stealthModeRequestedLabel: string = "";
  stealthModeActivatedLabel: string = "";
  logUploadInProgressLabel: string = "";
  logUploadRequestSentLabel: string = "";

  constructor(private trsService: TrsEventsService, private toastService: ToastrService, private agentListInfoService: AgentListInfo,
    private translationService: TranslocoService, public webrtcInfoService: WebRTCService, public teamCheckInService: TeamCheckInService) {
    this.pinLabel = this.translationService.translate("Pin");
    this.pinnedLabel = this.translationService.translate("Pinned");
    this.optionsLabel = this.translationService.translate("Options");
    this.archiveLabel = this.translationService.translate("Archive");
    this.unarchiveLabel = this.translationService.translate("UnArchive");
    this.uploadLogsLabel = this.translationService.translate("Upload Logs");
    this.chatReceivedLabel = this.translationService.translate("Chat Received");
    this.stealthModeRequestedLabel = this.translationService.translate("Stealth Mode Requested");
    this.stealthModeActivatedLabel = this.translationService.translate("Stealth Mode Activated");
    this.logUploadInProgressLabel = this.translationService.translate("Log Upload is in progress! Please try again later.");
    this.logUploadRequestSentLabel = this.translationService.translate("Request sent to server to upload logs");
  }

  ngOnInit(): void {
    if (this.agent != null)
      this.handleAuxCodeChange(this.agent.AgentCurrentAuxCode);

    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "AUXCODECHANGE_INTERNAL":
          if (this.agent != null && this.agent.LanID === response.data)
            this.handleAuxCodeChange(this.agent.AgentCurrentAuxCode);
          break;
        case "PROFILEPICTURE_RESPONSE":
          if (this.agent != null && this.agent.LanID === response.data)
            this.loadAgentProfilePicture();
          break;
        case "TEAMCHECKIN_UPDATE_AVAILABLE":
          this.checkInInfo = this.teamCheckInService.getTeamCheckInInfo(this.agent.LanID);
          break;
      }
    });

    this.loadAgentProfilePicture();
  }

  toggleAgentPin() {
    let data = {
      "AgentLanId": this.agent.LanID, // AgentId of the Agent to be Pinned or Unpinned
      "IsPinned": !this.agent.IsPinned // true if you wanto PIN this agent false if you wanto Unpin
    };
    this.sendEvent('CUSTOM_PIN_AGENT', data)
  }

  onClick(event: { target: any; }) {
    if (!this.agentView.nativeElement.contains(event.target)) {
      this.unSetMenuAgentLanId();
    }
  }

  unSetMenuAgentLanId() {
    this.menuAgentLanId = "";
  }

  settingsSelected(AgentLanId: string) {
    let data = {
      AgentLanId: this.agent.LanID,
      AgentTeamName: this.agent.AgentTeamName
    };
    if (this.menuAgentLanId) {
      this.menuAgentLanId = "";
      this.sendEvent('CUSTOM_SETTINGS_SELECTED', data)
      return;
    }
    this.sendEvent('CUSTOM_SETTINGS_SELECTED', data)
    this.menuAgentLanId = AgentLanId;
  }

  toggleAgentArchive() {
    let data = {
      "AgentLanId": this.agent.LanID, // AgentId of the Agent to be Archived or unarchived
      "IsArchived": !this.agent.IsArchived, // true if you want to Archive this agent false if you want to unarchive
      "AgentTeamName": this.agent.AgentTeamName
    };
    this.sendEvent('CUSTOM_ARCHIVE_AGENT', data);
    this.menuAgentLanId = '';
  }

  //log upload
  logUpload() {
    if (this.agent.UploadLogStatus === true) {
      this.toastService.warning(this.logUploadInProgressLabel);
      return;
    }
    if (this.agent.LoginStatus != 'Logged Out') {
      this.menuAgentLanId = "";
      this.agent.UploadLogStatus = true;

      this.sendEvent('LOGUPLOAD', { AgentLanId: this.agent.LanID });
      this.toastService.success(this.logUploadRequestSentLabel);

      setTimeout(() => {
        if (this.agent.UploadLogStatus === true) {
          log.info(`Upload Logs Timeout`);
          this.agent.UploadLogStatus = false;
        }
      }, 6000);
    }
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.trsService.evtdata.next(data);
  }

  handleAuxCodeChange = (currentAuxCode: string | null): void => {
    if (currentAuxCode != null)
      switch (currentAuxCode) {
        case "LoggedIn":
          this.agentConnectivityStatus = {
            class: "green",
            status: "LoggedIn",
            tooltip: this.translationService.translate("Logged In"),
          };
          break;
        case "0":
        case "Available":
          this.agentConnectivityStatus = {
            class: "orange",
            status: "Available",
            tooltip: this.translationService.translate(currentAuxCode),
          };
          break;
        case "Busy":
        case "Break":
        case "Meeting":
          this.agentConnectivityStatus = {
            class: "red",
            status: currentAuxCode,
            tooltip: this.translationService.translate(currentAuxCode),
          };
          break;
        case "LoggedOut":
        default:
          this.agentConnectivityStatus = {
            class: "grey",
            status: "LoggedOut",
            tooltip: this.translationService.translate("Logged Out"),
          };
          break;
      }
  }

  loadAgentProfilePicture = (): void => {
    if (this.agent.AgentProfilePic === null || this.agent.AgentProfilePic === "") {
      this.isProfilePictureLoaded = false;
      return;
    }

    let newImg = new Image;
    newImg.onload = ($event: Event): void => {
      this.isProfilePictureLoaded = true;
      this.loadedProfilePictureSource = newImg.src;
    }
    newImg.onerror = ($event: string | Event): void => {
      log.warn(`An error occurred while loading the profile picture for agent ${this.agent.LanID}`);

      this.isProfilePictureLoaded = false;

      if (this.agentListInfoService.GetProfilePicLoadRetryCount(this.agent.LanID) < 6) {
        setTimeout(() => this.sendEvent("REFRESHPROFILEPICTURE_REQUEST", {
          AgentLanId: this.agent.LanID,
        }), 30000);
        this.agentListInfoService.IncrementProfilePicLoadRetryCount(this.agent.LanID);
      }
      else log.warn(`Max retries reached for loading profile picture for agent ${this.agent.LanID}`);
    }
    newImg.src = this.agent.AgentProfilePic;
  }

  getAgentInitials = (): string => {
    if (this.agent != null)
      return `${this.agent.AgentFirstName?.charAt(0) ?? ''}${this.agent.AgentLastName?.charAt(0) ?? ''}`.toUpperCase();
    else return "";
  }
}